import type { Ref } from "react";

import { dot, label as labelClass, wrapper } from "~/components/StateDot.css";

/**
 * The liveness language, as a closed set. These are not outcomes
 * (succeeded / overdue — that's Badge's job); they say what a live thing
 * is doing right now. Domain vocabularies map ONTO this enum rather than
 * the component learning about any one domain.
 */
export type StateDotStatus =
  | "active"
  | "waiting"
  | "scheduled"
  | "idle"
  | "breach";

export interface StateDotProps {
  status: StateDotStatus;
  /**
   * Visible text beside the dot. State is never color alone: with no
   * label the dot still carries the status name for assistive tech, and
   * the caller is expected to sit it next to a glyph.
   */
  label?: string;
  ref?: Ref<HTMLSpanElement>;
}

/** An 8px status dot, optionally labelled. `active` pulses; nothing else does. */
export function StateDot({ status, label, ref }: StateDotProps) {
  return (
    <span ref={ref} className={wrapper}>
      <span className={dot[status]} role="img" aria-label={label ?? status} />
      {label ? <span className={labelClass}>{label}</span> : null}
    </span>
  );
}
